export const TitleTextStyle = {
    fill: '#fcd607',
    stroke: '#913600',
    strokeThickness: 6,
    dropShadow: true,
    dropShadowColor: '#913600',
    dropShadowDistance: 8,
    dropShadowAngle: 90,
};

export const YellowButtonTextStyle = {
    fill: '#ffffff',
    stroke: '#914200',
    strokeThickness: 6,
    dropShadow: true,
    dropShadowColor: '#914200',
    dropShadowDistance: 6,
    dropShadowAngle: 90,
};

export const WhiteTextWithVioletStrokeStyle = {
    fill: '#ffffff',
    stroke: '#781F6F',
    strokeThickness: 12,
};

export const YellowTextStyle = {
    fill: '#fcd607',
    stroke: '#914200',
    strokeThickness: 12,
};

export const YellowTextBoldStyle = {
    fill: '#fcd607',
    stroke: '#914200',
    strokeThickness: 6,
    dropShadow: true,
    dropShadowColor: '#914200',
    dropShadowDistance: 6,
    dropShadowAngle: 90,
};

export const BlueButtonTextStyle = {
    fill: '#ffffff',
    stroke: '#003e6c',
    strokeThickness: 6,
    dropShadow: true,
    dropShadowColor: '#003e6c',
    dropShadowDistance: 6,
    dropShadowAngle: 90,
};

export const GreenButtonTextStyle = {
    fill: '#ffffff',
    stroke: '#294900',
    strokeThickness: 6,
    dropShadow: true,
    dropShadowColor: '#294900',
    dropShadowDistance: 6,
    dropShadowAngle: 90,
};

export const RedButtonTextStyle = {
    fill: '#ffffff',
    stroke: '#600800',
    strokeThickness: 6,
    dropShadow: true,
    dropShadowColor: '#600800',
    dropShadowDistance: 6,
    dropShadowAngle: 90,
};

export const YellowButtonStrokeTextStyle = {
    fill: '#ffffff',
    stroke: '#914200',
    strokeThickness: 6,
};

export const BlueButtonStrokeTextStyle = {
    fill: '#ffffff',
    stroke: '#003e6c',
    strokeThickness: 6,
};

export const GreenButtonStrokeTextStyle = {
    fill: '#ffffff',
    stroke: '#294900',
    strokeThickness: 6,
};

export const RedButtonStrokeTextStyle = {
    fill: '#ffffff',
    stroke: '#600800',
    strokeThickness: 6,
};
